/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

function Form(_ref) {
  let {
    className,
    children,
    ...other
  } = _ref;
  const prefix = usePrefix();
  const classNames = cx(`${prefix}--form`, className);
  return /*#__PURE__*/React__default.createElement("form", _extends({
    className: classNames
  }, other), children);
}
Form.propTypes = {
  /**
   * Provide children to be rendered inside of the <form> element
   */
  children: PropTypes.node,
  /**
   * Provide a custom className to be applied on the containing <form> node
   */
  className: PropTypes.string
};

export { Form as default };
